import React from "react";
import { useParams } from "react-router-dom";

import DetailPage from "../components/DetailPage";
import { getIndustry } from "../data/industries";

function IndustryDetail() {
  const { slug } = useParams();
  const industry = getIndustry(slug);

  return (
    <DetailPage
      item={industry}
      kind="INDUSTRY"
      backTo="/industries"
      backLabel="Back to Industries"
      notFoundTitle="Industry not found"
      notFoundText="The industry you're looking for doesn't exist."
      listTitle="How We Help"
      listItems={industry?.highlights}
      useCases={industry?.useCases}
    />
  );
}

export default IndustryDetail;
